(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('footer-phone-field')) {
    class FooterPhoneField extends HTMLElement {
      connectedCallback() {
        this.countrySelect = this.querySelector('.footer-big-signup__country-code');
        this.countryFlag = this.querySelector('[data-country-flag]');
        this.countryDial = this.querySelector('[data-country-dial]');

        if (!this.countrySelect) return;

        this.handleCountryChange = this.updateCountry.bind(this);
        this.countrySelect.addEventListener('change', this.handleCountryChange);
        this.updateCountry();
      }

      disconnectedCallback() {
        if (this.countrySelect && this.handleCountryChange) {
          this.countrySelect.removeEventListener('change', this.handleCountryChange);
        }
      }

      updateCountry() {
        const selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex];
        if (!selectedOption) return;

        if (this.countryFlag) this.countryFlag.textContent = selectedOption.dataset.flag || '';
        if (this.countryDial) this.countryDial.textContent = selectedOption.value;
      }
    }

    customElements.define('footer-phone-field', FooterPhoneField);
  }

  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var initRelatedProductsCarousel = function(productRecommendationsSection) {
  var carousel = productRecommendationsSection.querySelector('.related-products__mobile-carousel');
  if (carousel === null || carousel.dataset.progressReady === 'true') { return; }

  var slider = carousel.querySelector('.related-collection.slider');
  var grid = carousel.querySelector('.related-products__mobile-grid');
  var indicator = carousel.querySelector('.related-products__carousel-progress span');
  var slides = grid
    ? Array.from(grid.children).filter(function(child) { return child.classList.contains('slider__item'); })
    : [];
  if (slider === null || indicator === null || slides.length < 2) { return; }

  carousel.dataset.progressReady = 'true';
  var animationFrame = null;

  var updateIndicator = function() {
    animationFrame = null;
    var maximumScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
    var progress = maximumScroll > 0
      ? Math.min(1, Math.max(0, Math.abs(slider.scrollLeft) / maximumScroll))
      : 0;
    var travel = progress * (slides.length - 1) * 100;
    indicator.style.transform = 'translateX(' + travel + '%)';
  };

  slider.addEventListener('scroll', function() {
    if (animationFrame === null) {
      animationFrame = requestAnimationFrame(updateIndicator);
    }
  }, { passive: true });

  updateIndicator();
};

var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector('.related-products');
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      initRelatedProductsCarousel(productRecommendationsSection);
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('.related-products[data-section-id="' + event.detail.sectionId + '"]')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
